import React, { useEffect, useRef } from 'react';

interface UploadProgressModalCompProps {
    show: boolean;
    title: string;
    progress: number;
    errorMessage?: string;
    onClose: () => void;
    onShown?: () => void;
}

const UploadProgressModalComp: React.FC<UploadProgressModalCompProps> = ({
    show,
    title,
    progress,
    errorMessage = '',
    onClose,
    onShown
}) => {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const bsModalRef = useRef<any>(null);

    useEffect(() => {
        if (!modalRef.current) return;

        const currentModal = modalRef.current;
        bsModalRef.current = (window as any).bootstrap.Modal.getOrCreateInstance(currentModal);

        const handleHidden = () => onClose();
        const handleShown = () => onShown?.();

        currentModal.addEventListener('hidden.bs.modal', handleHidden);
        currentModal.addEventListener('shown.bs.modal', handleShown);

        return () => {
            currentModal.removeEventListener('hidden.bs.modal', handleHidden);
            currentModal.removeEventListener('shown.bs.modal', handleShown);
            bsModalRef.current?.dispose();
            bsModalRef.current = null;
        };
    }, []);

    useEffect(() => {
        if (!bsModalRef.current) return;

        if (show) {
            bsModalRef.current.show();
        } else {
            bsModalRef.current.hide();
        }
    }, [show]);

    return (
        <div
            className="modal fade"
            tabIndex={-1}
            ref={modalRef}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content rounded-0">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                    </div>
                    <div className="modal-body">
                        {errorMessage ? (
                            <div className="alert alert-danger mb-0" role="alert">
                                {errorMessage}
                            </div>
                        ) : (
                            <div className="progress">
                                <div
                                    className="progress-bar progress-bar-striped progress-bar-animated bg-success"
                                    role="progressbar"
                                    style={{ width: `${progress}%` }}
                                    aria-valuenow={progress}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                >
                                    {progress}%
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadProgressModalComp;